import React, { ChangeEvent, useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { IAppState } from 'core/store/store'
import styles from '../update-services/UpdateServices.module.scss'
import { Translate } from 'react-localize-redux'
import {
  Button,
  ButtonType,
  DatePicker,
  Form,
  FormGroup,
  Input,
  SubmitButton,
} from '@digicert/dcone-common-ui'
import { translate } from 'shared/helpers/utils'
import { editApiToken, fetchApiTokens } from 'secure-pages/api-tokens/ApiTokens.actions'
import { ISort } from 'core/actions/Actions.interfaces'
import { disabledDateFromTo } from 'shared/helpers/DateTimeHelper'
import dayjs, { Dayjs } from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc);

export const UpdateApiToken = (
  { onCancel, fetchApiTokens, editApiToken, setTokens, token }) => {

  const [name, setName] = useState<string>(token.name)
  const [nameExists, setNameExist] = useState<boolean>(false)
  const [date, setDate] = useState<Dayjs>()

  useEffect(() => {
    setName(token.name)
    setNameExist(false)
    if (token.end_date) {
      setDate(dayjs.utc(token.end_date))
    }
  }, [onCancel])

  const handleCancel = (e) => {
    e.preventDefault()
    if (onCancel) {
      onCancel(e)
    }
  }

  const submit = (e) => {
    e.preventDefault()
    const payload = {
      name: name,
      end_date: date,
      permissions: token.permissions,
      enabled: token.enabled
    }
    editApiToken(token.id, payload).then(() => {
      fetchApiTokens().then((response: any) => {
        setTokens(response.items)
      })
    })
    handleCancel(e)
  }

  const onNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value)
  }

  const onApiTokenNameBlur = (event: ChangeEvent<HTMLInputElement>) => {
    onNameChange(event)
    const params: ISort = { limit: 20, offset: 0 }
    if (event.target.value.trim() !== '') {
      fetchApiTokens(params, { name: event.target.value.trim() }).then(res => {
        if (res.items.length > 0) {
          setNameExist(true)
        } else {
          setNameExist(false)
        }
      })
    }
  }

  const validateApiTokenName = useCallback(() => {
    if (nameExists) {
      return translate('common.form.validation.alreadyUsed') as string
    }
  }, [nameExists])

  const onDateChange = useCallback((value, dateString) => {
    setDate(value);
  }, [date]);

  return (
    <>
      <div className={styles.editServices}>
        <Form center={false} onSubmit={(e) => submit(e)}>

          <FormGroup>
            <Input
              name='api_token_name'
              label={<Translate id='common.form.name' />}
              required
              value={name}
              errors={{
                valueMissing: translate('common.form.validation.required') as string
              }}
              className={styles.apiName}
              onChange={onNameChange}
              validate={validateApiTokenName}
              onBlur={(event) => onApiTokenNameBlur(event)}
            />
          </FormGroup>
          <FormGroup>
            <DatePicker
              label={translate('serviceUser.endDate') as string}
              id='api_token_datepicker'
              value={date}
              onChange={onDateChange}
              disabledDate={disabledDateFromTo(dayjs().utc().format('YYYY-MM-DD'))}
            />
          </FormGroup>

          <div className={styles.formActions}>
            <Button buttonType={ButtonType.SECONDARY} onClick={handleCancel}>
              <Translate id='common.form.buttons.cancelBtn' />
            </Button>
            <SubmitButton>
              <Translate id='apiTokens.updateToken' />
            </SubmitButton>
          </div>

        </Form>
      </div>
    </>
  )
}

export default connect(
  (state: IAppState) => {
    return {
    }
  },
  {
    editApiToken,
    fetchApiTokens
  }
)(UpdateApiToken)
